import { render, staticRenderFns } from "./c_swiper.vue?vue&type=template&id=33e19f6a&scoped=true&"
import script from "./c_swiper.vue?vue&type=script&lang=js&"
export * from "./c_swiper.vue?vue&type=script&lang=js&"
import style0 from "./c_swiper.vue?vue&type=style&index=0&id=33e19f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e19f6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VImg,VSheet})
